module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/add_medical_leaders/special01-928abba2145673ed31ae2a1bc99b03d4.png";